import { token, user } from '@/store/modules/auth/auth-state';

export const getAuthToken = () => {
  return token.value;
};

export const getUserLanguage = () => {
  return user.value?.locale;
};
